import { Injectable } from "@angular/core";
import { Location } from "../models/location";
import { StudentGet } from "../models/student-get";
import { ClassSchedule } from "../models/class-schedule";
import { AddressGet } from "../models/address-get";
import { State } from "../models/state";
import { ClassScheduleSession } from "../models/class-schedule-session";
import { ClassMaster } from "../models/class-master";
import { CreateLogin } from "../models/create-login";
import { AdminStudentSearchResult } from "../models/admin-student-search-result";
import { environment } from "../../environments/environment";
import { Http, Headers, RequestOptions } from "@angular/http";

@Injectable()
export class DataSharingService {
  selectedMasterClassId: string;
  registerPhaseClassSchedule: ClassSchedule;
  currentStudent: StudentGet;
  roleloggedin: string;
  private _settingsUrl: string = `${environment.apiRootURL}/settings`;

  constructor(private _http: Http) {
    this.roleloggedin = "0";
  }

  getSetting(type: string, name: string) {
    console.log("HTTP GET a setting");
    return this._http
      .get(`${this._settingsUrl}/types/${type}/${name}`)
      .map((response) => response.json());
  }

  updateSetting(type: string, name: string, value: string) {
    console.log("HTTP update a setting");
    return this._http
      .get(`${this._settingsUrl}/update/${type}/${name}/${value}`)
      .map((response) => response.json());
  }

  setCourseDeliveryType(type: string) {
    window.sessionStorage.setItem("courseDeliveryType", type);
  }

  getCourseDeliveryType() {
    return window.sessionStorage.getItem("courseDeliveryType");
  }

  setClassTypeId(typeId: string) {
    window.sessionStorage.setItem("classTypeId", typeId);
  }

  getClassTypeId() {
    return window.sessionStorage.getItem("classTypeId");
  }

  setDistanceType(typeId: string) {
    window.sessionStorage.setItem("distanceType", typeId);
  }

  getDistanceType() {
    return window.sessionStorage.getItem("distanceType");
  }

  setClassChkNo(chkno: string) {
    window.sessionStorage.setItem("ChkNo", chkno);
  }

  getClassChkNo() {
    return window.sessionStorage.getItem("ChkNo");
  }

  setClassAmount(amount: string) {
    window.sessionStorage.setItem("ClassAmount", amount);
  }

  getClassAmount() {
    return window.sessionStorage.getItem("ClassAmount");
  }

  setRegisterProgress(step: string) {
    window.sessionStorage.setItem("registerProgress", step);
  }

  getRegisterProgress() {
    return window.sessionStorage.getItem("registerProgress");
  }

  setRegisterOnlineProgress(step: string) {
    window.sessionStorage.setItem("registerOnlineProgress", step);
  }

  getRegisterOnlineProgress() {
    return window.sessionStorage.getItem("registerOnlineProgress");
  }

  setSelectedLocation(location: Location) {
    window.sessionStorage.setItem(
      "selectedLocation",
      JSON.stringify({ location: location })
    );
  }

  getSelectedLocation() {
    return JSON.parse(window.sessionStorage.getItem("selectedLocation"));
  }

  setClassMaster(classmaster: ClassMaster) {
    window.sessionStorage.setItem(
      "classmaster",
      JSON.stringify({ classmaster: classmaster })
    );
  }

  getClassMaster() {
    return JSON.parse(window.sessionStorage.getItem("classmaster"));
  }

  setSelectedClassSchedule(classSchedule: ClassSchedule) {
    window.sessionStorage.setItem(
      "selectedClassSchedule",
      JSON.stringify({ classSchedule: classSchedule })
    );
  }

  getSelectedClassSchedule() {
    return JSON.parse(window.sessionStorage.getItem("selectedClassSchedule"));
  }

  setAdminUser(user: CreateLogin) {
    window.sessionStorage.setItem("adminUser", JSON.stringify({ user }));
  }

  getAdminUser() {
    return JSON.parse(window.sessionStorage.getItem("adminUser"));
  }

  setCurrentUser(user: CreateLogin) {
    window.sessionStorage.setItem("currentUser", JSON.stringify({ user }));
    if (user == null) {
      this.setRoleId("0");
    } else {
      this.setRoleId(user.roleId);
    }
  }

  getCurrentUser() {
    return JSON.parse(window.sessionStorage.getItem("currentUser"));
  }

  setSelectedClassId(selectedClass: string) {
    window.sessionStorage.setItem("selectedClass", selectedClass);
  }

  getSelectedClassId() {
    return window.sessionStorage.getItem("selectedClass");
  }

  setStudentSelected(student: AdminStudentSearchResult) {
    window.sessionStorage.setItem(
      "studentSelected",
      JSON.stringify({ student })
    );
  }

  getStudentSelected() {
    return JSON.parse(window.sessionStorage.getItem("studentSelected"));
  }

  setPaymentMessage(paymentMessage: string) {
    window.sessionStorage.setItem("paymentMessage", paymentMessage);
  }

  getPaymentMessage() {
    return window.sessionStorage.getItem("paymentMessage");
  }

  clrPaymentMessage() {
    window.sessionStorage.removeItem("paymentMessage");
    window.sessionStorage.removeItem("fullPaymentMessage");
  }

  setFullPaymentMessage(paymentMessage: string) {
    window.sessionStorage.setItem("fullPaymentMessage", paymentMessage);
  }

  getFullPaymentMessage() {
    return window.sessionStorage.getItem("fullPaymentMessage");
  }

  setRegisterAdditional(RegisterAdditional: boolean) {
    window.sessionStorage.setItem(
      "RegisterAdditional",
      RegisterAdditional ? "1" : "0"
    );
  }

  getRegisterAdditional() {
    const RegisterAdditional = window.sessionStorage.getItem(
      "RegisterAdditional"
    );
    if (RegisterAdditional == null) {
      return false;
    }
    return RegisterAdditional === "1";
  }

  setCurrentStudent(student: StudentGet) {
    window.sessionStorage.setItem(
      "currentStudent",
      JSON.stringify({ student })
    );
  }

  getCurrentStudent() {
    return JSON.parse(window.sessionStorage.getItem("currentStudent"));
  }

  setAuthToken(authtoken: string) {
    window.sessionStorage.setItem("authtoken", authtoken);
  }

  getAuthToken() {
    return window.sessionStorage.getItem("authtoken");
  }

  setRoleId(roleId: string) {
    window.sessionStorage.setItem("roleId", roleId);
    this.roleloggedin = roleId;
  }

  getRoleId() {
    let role = window.sessionStorage.getItem("roleId");
    if (role == null) {
      role = "0";
    }
    return role;
  }

  logout() {
    this.setCurrentUser(null);
    this.setAdminUser(null);
    this.setCurrentStudent(null);
  }

  getTestLocations() {
    var locations: Location[] = [];

    var location1 = new Location();
    location1.id = "123";
    location1.name = "Plymouth Senior Center";
    location1.address = new AddressGet();
    location1.address.address1 = "11111 11th Ave";
    location1.address.address2 = "";
    location1.address.city = "Plymouth";
    location1.address.state = new State();
    location1.address.state.id = "1";
    location1.address.state.abbreviation = "MN";
    location1.address.state.name = "Minnesota";
    location1.address.zipCode = "55441";
    location1.address.latitude = "";
    location1.address.longitude = "";
    location1.address.formattedAddress = `${location1.address.address1}, ${location1.address.city} ${location1.address.state.abbreviation}`;
    location1.distanceToStudentDisplay = "1.05 miles";
    var classSchedule1 = new ClassSchedule();
    classSchedule1.id = "1";
    classSchedule1.active = true;
    var session1 = new ClassScheduleSession();
    session1.id = "1";
    session1.description = "";
    session1.startDateTime = "";
    session1.endDateTime = "";
    session1.formattedDate = "January 22, 2018 (Monday)";
    session1.formattedTime = "8:00am - Noon";
    session1.active = true;
    var session2 = new ClassScheduleSession();
    session2.id = "2";
    session2.description = "";
    session2.startDateTime = "";
    session2.endDateTime = "";
    session2.formattedDate = "January 23, 2018 (Tuesday)";
    session2.formattedTime = "8:00am - Noon";
    session2.active = true;
    classSchedule1.classScheduleSessions = [session1, session2];
    var classSchedule2 = new ClassSchedule();
    classSchedule2.id = "2";
    classSchedule2.active = true;
    var session3 = new ClassScheduleSession();
    session3.id = "3";
    session3.description = "";
    session3.startDateTime = "";
    session3.endDateTime = "";
    session3.formattedDate = "January 26, 2018 (Friday)";
    session3.formattedTime = "8:00am - Noon";
    session3.active = true;
    var session4 = new ClassScheduleSession();
    session4.id = "4";
    session4.description = "";
    session4.startDateTime = "";
    session4.endDateTime = "";
    session4.formattedDate = "January 27, 2018 (Saturday)";
    session4.formattedTime = "8:00am - Noon";
    session4.active = true;
    classSchedule2.classScheduleSessions = [session3, session4];

    var classSchedule3 = new ClassSchedule();
    classSchedule3.id = "3";
    classSchedule3.active = true;
    var session5 = new ClassScheduleSession();
    session5.id = "5";
    session5.description = "";
    session5.startDateTime = "";
    session5.endDateTime = "";
    session5.formattedDate = "February 20, 2018 (Tuesday)";
    session5.formattedTime = "5:00pm - 9:00pm";
    session5.active = true;
    var session6 = new ClassScheduleSession();
    session6.id = "6";
    session6.description = "";
    session6.startDateTime = "";
    session6.endDateTime = "";
    session6.formattedDate = "February 21, 2018 (Wednesday)";
    session6.formattedTime = "5:00pm - 9:00pm";
    session6.active = true;
    classSchedule3.classScheduleSessions = [session5, session6];
    location1.classSchedules = [classSchedule1, classSchedule2, classSchedule3];

    var location2 = new Location();
    location2.id = "456";
    location2.name = "Minnetonka YMCA";
    location2.address = new AddressGet();
    location2.address.address1 = "22222 2nd Street";
    location2.address.address2 = "";
    location2.address.city = "Minnetonka";
    location2.address.state = new State();
    location2.address.state.id = "1";
    location2.address.state.abbreviation = "MN";
    location2.address.state.name = "Minnesota";
    location2.address.zipCode = "55441";
    location2.address.latitude = "";
    location2.address.longitude = "";
    location2.address.formattedAddress = `${location2.address.address1}, ${location2.address.city} ${location2.address.state.abbreviation}`;
    location2.distanceToStudentDisplay = "4.89 miles";
    var classSchedule4 = new ClassSchedule();
    classSchedule4.id = "4";
    classSchedule4.active = true;
    var session7 = new ClassScheduleSession();
    session7.id = "7";
    session7.description = "";
    session7.startDateTime = "";
    session7.endDateTime = "";
    session7.formattedDate = "January 22, 2018 (Monday)";
    session7.formattedTime = "8:00am - Noon";
    session7.active = true;
    var session8 = new ClassScheduleSession();
    session8.id = "8";
    session8.description = "";
    session8.startDateTime = "";
    session8.endDateTime = "";
    session8.formattedDate = "January 23, 2018 (Tuesday)";
    session8.formattedTime = "8:00am - Noon";
    session8.active = true;
    classSchedule4.classScheduleSessions = [session7, session8];
    var classSchedule5 = new ClassSchedule();
    classSchedule5.id = "5";
    classSchedule5.active = true;
    var session9 = new ClassScheduleSession();
    session9.id = "9";
    session9.description = "";
    session9.startDateTime = "";
    session9.endDateTime = "";
    session9.formattedDate = "January 26, 2018 (Friday)";
    session9.formattedTime = "8:00am - Noon";
    session9.active = true;
    var session10 = new ClassScheduleSession();
    session10.id = "10";
    session10.description = "";
    session10.startDateTime = "";
    session10.endDateTime = "";
    session10.formattedDate = "January 27, 2018 (Saturday)";
    session10.formattedTime = "8:00am - Noon";
    session10.active = true;
    classSchedule5.classScheduleSessions = [session9, session10];

    var classSchedule6 = new ClassSchedule();
    classSchedule6.id = "6";
    classSchedule6.active = true;
    var session11 = new ClassScheduleSession();
    session11.id = "11";
    session11.description = "";
    session11.startDateTime = "";
    session11.endDateTime = "";
    session11.formattedDate = "February 20, 2018 (Tuesday)";
    session11.formattedTime = "5:00pm - 9:00pm";
    session11.active = true;
    var session12 = new ClassScheduleSession();
    session12.id = "12";
    session12.description = "";
    session12.startDateTime = "";
    session12.endDateTime = "";
    session12.formattedDate = "February 21, 2018 (Wednesday)";
    session12.formattedTime = "5:00pm - 9:00pm";
    session12.active = true;
    classSchedule6.classScheduleSessions = [session11, session12];

    location2.classSchedules = [classSchedule4, classSchedule5, classSchedule6];

    locations = [location1, location2];
    return locations;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/data-sharing.service.ts